import { Reference_Code__c, Email } from "../process/marketoFields";
import {
  validateEmail,
  validatePhone,
  validatePhoneInt,
} from "../../../utils/validators";

export const validateField = ($el) => {
  let name = $el.attr("name");
  let type = $el.attr("type");
  let value = $el.val();
  let fieldValue = {
    name,
    value,
  };

  const isHidden = type === "hidden";
  if (isHidden) {
    return fieldValue;
  }

  const isRadio = type === "radio";
  if (isRadio) {
    name = $el.filter(":checked").attr("name");
    value = $el.filter(":checked").val();
    fieldValue = {
      name,
      value,
    };
    return fieldValue;
  }

  const isCheckbox = type === "checkbox";
  if (isCheckbox) {
    name = $el.prop("checked") ? name : null;
    value = $el.prop("checked") ? true : null;
    fieldValue = {
      name,
      value,
    };
  }

  const isRequired = $el.attr("required");

  if (isRequired && !value) {
    $el.parents(".field-wrap").addClass("error");
    const errorMessage =
      $el.data().customError ||
      `${
        window.translate.error_please_include_your
      } ${$el.data().label.toLowerCase()}`;
    $el.parents(".field-wrap").find(".error-field").text(errorMessage);
    return null;
  } else if (isRequired && value) {
    $el.parents(".field-wrap").addClass("good");
    $el.parents(".field-wrap").removeClass("error");
    $el.parents().find(".error-field").text("");
  }

  const isMiddleInitial = name === "MiddleInitial";
  if (isMiddleInitial && value.length > 1) {
    $el.parent().addClass("error");
    $el.parent().removeClass("good");
    $el.next().text(window.translate.error_one_character);
    return null;
  }

  const isEmail = name === Email;
  if (isEmail && !validateEmail(value)) {
    $el.parents(".field-wrap").addClass("error");
    $el.parents(".field-wrap").removeClass("good");
    $el
      .parent()
      .find(".error-field")
      .text(window.translate.error_correct_email);
    return null;
  }

  const isPhone = type === "tel";
  const countryPhone = isPhone
    ? $el.parents(".field-wrap").find(".f_country").val()
    : null;
  if (isPhone && countryPhone === "US" && !validatePhone(value)) {
    $el.parents(".field-wrap").addClass("error");
    $el.parents(".field-wrap").removeClass("good");
    $el
      .parent()
      .find(".error-field")
      .text(window.translate.error_correct_phone);
    return null;
  } else if (isPhone && !validatePhoneInt(value)) {
    $el.parents(".field-wrap").addClass("error");
    $el.parents(".field-wrap").removeClass("good");
    $el
      .parent()
      .find(".error-field")
      .text(window.translate.error_correct_phone);
    return null;
  } else if (isPhone) {
    $el.parents(".field-wrap").removeClass("error");
    if (!$el.parent().find(".error-field").hasClass("custom-control-label")) {
      $el.parent().find(".error-field").text("");
    }
  }

  const isReferenceCode = name === Reference_Code__c;
  if (isReferenceCode && $el.parent().hasClass("error")) {
    fieldValue.value = "";
    return fieldValue;
  }

  $el.parent(".field-wrap").removeClass("error");

  if (!$el.parent().find(".error-field").hasClass("custom-control-label")) {
    $el.parent().find(".error-field").text("");
  }

  return fieldValue;
};

export const validateForm = ($elements) => {
  const output = {
    isValidated: true,
    values: {},
  };

  $elements.each((_, el) => {
    const isValid = validateField($(el));
    if (isValid) {
      output.values[isValid.name] = isValid.value;
      return;
    }
    output.isValidated = false;
  });

  return output;
};
